import { render, staticRenderFns } from "./bindInfo.vue?vue&type=template&id=c28c5f02&scoped=true&"
import script from "./bindInfo.vue?vue&type=script&lang=js&"
export * from "./bindInfo.vue?vue&type=script&lang=js&"
import style0 from "./bindInfo.vue?vue&type=style&index=0&id=c28c5f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28c5f02",
  null
  
)

export default component.exports